import { ASSET_DESCRIPTION, ColumnConfig, ColumnText, ComponentConfig, DefaultFormatter, ISODateFormatter, LodashExtractor, TabConfig, TablePerPortfolioSeriesExtractorConfig } from '@ddt-web/data-service';

import { CommonPeriodMapper } from '../mapper/common-period.mapper';

export const PERFORMANCE_COMMON_PERIOD = new TabConfig(
	'performance-common-period',
	null,
	new TablePerPortfolioSeriesExtractorConfig(
		new CommonPeriodMapper(
			['performance', 'positionDetails', 'associatedPortfolios'],
			'performance.performance.assetPerformanceDateRanges',
			'positionDetails.children',
			'associatedPortfolios.children'
		),
		null,
		[
			new ColumnConfig(
				new ColumnText('COMMON_PERIOD_TICKER', 'Ticker', null, { align: 'left' }),
				null,
				new LodashExtractor('ticker'),
				'ticker'
			),
			new ColumnConfig(new ColumnText('COMMON_PERIOD_NAME', 'Fund Name', null, { align: 'left' }), null, ASSET_DESCRIPTION, 'description'),
			new ColumnConfig(null, null, new LodashExtractor('portfolioId'), 'portfolioId', DefaultFormatter.instance, null, false),
			new ColumnConfig(
				new ColumnText('COMMON_PERIOD_START_DATE', 'Start Date', null, { align: 'right' }),
				new ColumnText(
					'COMMON_PERIOD_START_DATE_INFOBUBBLE',
					'COMMON_PERIOD_START_DATE_INFOBUBBLE'
				),
				new LodashExtractor('interval.startDate'),
				'startDate',
				new ISODateFormatter(ISODateFormatter.SHORT)
			),
			new ColumnConfig(null, null, new LodashExtractor('interval.stopDate'), 'endDate', DefaultFormatter.instance, null, false)
		],
		ComponentConfig.PORTFOLIO_NAME_COLUMN
	)
);
